angular.module('ApptBookApp').directive('appointmentbookheader', function () {
    return {
        restrict: "E",
        replace: true,
        transclude: true,
        templateUrl: "app/plugins/AppointmentBook/views/directives/AppointmentBookHeader.html"
    }
});